import { types as sdkTypes } from '../util/sdkLoader';

const { Money } = sdkTypes;

export const isStripeConnected = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.publicData?.isStripeConnected || false;
};
export const isPaypalConnected = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.publicData?.isPaypalConnected || false;
};
export const getPayPalMerchantId = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.publicData?.merchantId;
};
export const getRecentSearches = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.privateData?.recentSearches || [];
};
export function retrieveUserWishlist(user) {
  if (!user?.id) return null;

  return user.attributes?.profile?.publicData?.wishlist || [];
}
export const getOwnShippingPreference = user => {
  if (!user?.id) return null;

  return user?.attributes?.profile?.protectedData?.shippingPreference || null;
};

export const getThresholdParams = user => {
  if (!user?.id) return null;

  const protectedData = user?.attributes?.profile?.protectedData;

  return {
    thresholdAmount: new Money(protectedData?.thresholdAmount, protectedData?.thresholdCurrency),
    thresholdCurrency: protectedData?.thresholdCurrency,
    threshold: protectedData?.threshold,
  };
};

export const getOtherShippingPreferences = user => {
  return user?.id ? user?.attributes?.profile?.protectedData?.otherShippingPreferences ?? {} : null;
};
function transformShippingDetails(address) {
  if (!address) return null;

  const { street1, street2, street3, phone, ...rest } = address;

  // Return the transformed object with line1, line2, and line3
  return {
    ...rest,
    line1: street1 || null,
    line2: street2 || null,
    line3: street3 || null,
    phoneNumber: phone,
  };
}

export const getShippingDetails = user => {
  const address = user?.id && user?.attributes?.profile?.protectedData?.shippoAddress;
  const transformedDetails = transformShippingDetails(address);

  return transformedDetails || null;
};

export const getUsername = user => {
  return user?.id ? user?.attributes?.profile?.publicData?.username ?? null : null;
};
export const getStoreName = user => {
  return user?.id ? user?.attributes?.profile?.publicData?.storeName ?? null : null;
};
export const getAuthorBio = user => {
  return user?.id ? user?.attributes?.profile?.bio ?? null : null;
};
export const getDisplayName = author => {
  if (!author || !author.id || !author.attributes) return 'Tutulist User';

  const profile = author.attributes.profile;
  const hasName = profile?.firstName && profile?.lastName;

  // Return full name if available, otherwise fallback to display name or default
  if (hasName) {
    return `${profile.firstName} ${profile.lastName}`;
  } else if (profile?.displayName) {
    return profile.displayName;
  }

  return 'Tutulist User';
};

export const getVacationMode = user => {
  return user?.id ? user?.attributes?.profile?.publicData?.vacationMode ?? false : false;
};

export const checkIfEnabledNonUSOrders = user => {
  return user?.id ? user?.attributes?.profile?.protectedData?.enableNonUSOrders ?? 'no' : 'no';
};

export function getUserCartDetails(user) {
  // Consolidated null/undefined checks for robustness:
  if (!user || !user.id) {
    // Handle missing user or user ID gracefully
    return null;
  }

  // Combine optional chaining with default value for concise and safe access:
  const publicData = user.attributes?.profile?.publicData || {};
  return publicData.cartItems ?? [];
}
